import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { getGlobalParams } from "src/common/globalParams";
import { LogoIcon } from "src/icons";

import { RenderLeftMenuItem2 } from "./components";
import { LeftMenuButtonTrigger } from "./components/LeftMenuButtonTrigger/LeftMenuButtonTrigger";
import * as styles from "./LeftMenu.module.less";
import { leftMenuItems } from "./leftMenuItems";
import { leftMenuStore as store } from "./leftMenuStore";

const handleKeyDown = (event: KeyboardEvent) => {
  if (event.key === "Escape") {
    store.close();
  }
};
const handleClick = (event: React.MouseEvent) => {
  event.stopPropagation();
  store.close();
};

export const LeftMenu: React.FC = observer(() => {
  useEffect(() => {
    if (!store.isOpen) return undefined;
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [store.isOpen]);

  if (!store.isOpen) return null;

  const closeMenu = () => store.close();

  return (
    <>
      <div className={styles.box}>
        <div className={styles.menuHeader}>
          <div className={styles.logoBox}>
            <LogoIcon className={styles.logo} />
            {getGlobalParams().title}
          </div>
          <LeftMenuButtonTrigger />
        </div>

        {leftMenuItems.map((item) => (
          <RenderLeftMenuItem2
            key={item.key}
            item={item}
            closeMenu={closeMenu}
          />
        ))}
      </div>

      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div tabIndex={-1} className={styles.backdrop} onClick={handleClick} />
    </>
  );
});
